import { Settings } from "../Settings"
import { JsonProduct } from "./json-data-types/JsonProduct"

declare global{
    const fbq:any
    // interface Window{
    //     fbq: any
    // }
}


export module FacebookPixel{
    function checkIfInProduction(){
        return Settings.isProduction && window.location.host.indexOf('localhost')===-1
    }

    export async function addProductToBasketAsync(product:JsonProduct, quantity:number, productAttributes?:Object){
        if(!checkIfInProduction()) return
        if(!fbq){
            console.error('addProductToBasketAsync failed: no fbq')
            return
        }
        fbq('track', 'AddToCart', {
            content_type:'product', 
            contents:[
                {id:product.sku, quantity}
            ]
        });
    }

    export async function addProductToFavorites(product:JsonProduct){
        if(!checkIfInProduction()) return
        if(!fbq){
            console.error('addProductToFavorites failed: no fbq')
            return
        }
        fbq('track', 'AddToWishlist', {content_ids:[product.sku]});
    }

    export async function newUserRegistration(){
        if(!checkIfInProduction()) return
        if(!fbq){
            console.error('newUserRegistration failed: no fbq')
            return
        }
        fbq('track', 'CompleteRegistration');
    }

}